module.exports = __webpack_public_path__ + "static/media/mg2.d75259af.png";